import React, { ChangeEvent } from 'react'
import { FeedbackText } from '@entur/form'
import { ChoiceChipGroup } from '@entur/chip'
import styled from 'styled-components'
import { borderWidths, colors, space } from '@entur/tokens'
import { validateFormField, ValidationFormField } from '../../utils/form-utils'

const FeedbackTextContainer = styled.div`
  border-top: ${borderWidths.default}px solid ${colors.validation.lava};
  margin-top: ${space.extraSmall2}px;
`

type Props = {
  children?: React.ReactNode
  field: ValidationFormField<string>
  update: (value: ValidationFormField<string>) => void
}

export const ValidatableChoiceChipGroup = ({ children, field, update }: Props) => {
  const validateAndUpdate = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedField = {
      ...field,
      value: (event.target as HTMLInputElement).value,
    }
    const validatedFormField = validateFormField(updatedField) as ValidationFormField<string>
    update(validatedFormField)
  }

  return (
    <>
      <ChoiceChipGroup
        name={field.fieldName}
        label={field.displayName}
        onChange={validateAndUpdate}
        value={field.value}
      >
        {children}
      </ChoiceChipGroup>
      {field.variant === 'error' && (
        <FeedbackTextContainer>
          <FeedbackText variant={'error'}>Velg en relasjon</FeedbackText>
        </FeedbackTextContainer>
      )}
    </>
  )
}
